<template>
  <div class="py-8">
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-light-blue">{{ icons.arrowLeft }}</v-icon>
        <router-link class="text-decoration--none" :to="{ name: 'sites' }"
          >Sites</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <site-banner @change="onChangeImage" />
    <div
      class="ml-5 v-messages theme--light error--text"
      v-if="form.$getError('banner')"
    >
      {{ form.$getError('banner')[0] }}
    </div>

    <div class="ma-4" v-if="form">
      <div class="d-flex my-6">
        <v-form
          ref="formAddSite"
          style="width: 400px"
          enctype="multipart/form-data"
        >
          <label class="text-field-label">Site Name</label>
          <v-text-field
            flat
            solo
            required
            class="mt-2"
            v-model="form.name"
            :error-messages="form.$getError('name')"
            :loading="loading"
            :rules="[rules.required]"
          ></v-text-field>

          <label class="text-field-label">Address</label>
          <place-autocomplete
            v-model="form.address"
            name="location"
            :api-key="$env.placesApiKey"
            :input-state="null"
            :input-error="form.$getError('address')"
            input-class="ellipsis w-100"
          ></place-autocomplete>

          <div class="mt-4">
            <v-btn
              color="primary"
              depressed
              class="mr-4 px-6"
              height="40px"
              @click="submit"
              :loading="form.$busy"
              >Save</v-btn
            >
          </div>
        </v-form>
      </div>
    </div>

    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar.show" right :color="snackbar.color">
      {{ snackbar.message }}
      <v-btn text @click="snackbar.show = false">OK</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mdiChevronLeft, mdiCheck, mdiAlertCircleOutline } from '@mdi/js'
import { mapActions } from 'vuex'
import Compressor from 'compressorjs'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import SiteBanner from '@/components/photos/SiteBanner'
import PlaceAutocomplete from '@/components/autocomplete/PlaceAutocomplete'
import Form from '@/utils/form'
import store from '@/store'
export default {
  name: 'AddSite',

  components: {
    AppBarNavIcon,
    SiteBanner,
    PlaceAutocomplete
  },

  data() {
    return {
      icons: {
        arrowLeft: mdiChevronLeft,
        check: mdiCheck,
        alert: mdiAlertCircleOutline
      },
      loading: false,
      deleteDialog: false,
      form: new Form({
        name: '',
        address: '',
        banner: ''
      }),
      showCropperModal: false,
      tabItems: [{ tab: 'Info' }, { tab: 'Chats' }],
      rules: {
        required: value => !!value || 'This field is required.'
      },
      snackbar: {
        show: false,
        message: null,
        color: ''
      }
    }
  },

  computed: {
    displayName() {
      return this.form.name || this.form.email
    }
  },

  methods: {
    ...mapActions({
      createSite: 'site/createSite'
    }),

    onChangeImage(blob) {
      if (blob.size < 1000000) {
        this.form.$clearErrors()

        let _this = this
        // eslint-disable-next-line
        new Compressor(blob, {
          quality: 0.2,
          success(result) {
            _this.form.banner = result
          }
        })
      } else {
        this.form.$setErrors({ banner: ['Image size is too large'] })
      }
    },

    async submit() {
      if (this.$refs.formAddSite.validate() && !this.form.$getError('banner')) {
        this.form.$busy = true
        this.form.$clearErrors()

        let data = new FormData()
        data.append('name', this.form.name)
        data.append('address', this.form.address)
        data.append('banner', this.form.banner)

        this.createSite(data)
          .then(() => {
            this.form.$busy = false
            this.showSnackbar('Site details successfully saved!', 'success')
          })
          .catch(err => {
            this.form.$busy = false
            if (err.response.status === 422) {
              this.form.$setErrors(err.response.data.errors)
            }
          })
      }
    },

    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    }
  },
  beforeRouteEnter(to, from, next) {
    if (store.state.auth.user && store.state.auth.user.is_admin) {
      next()
    } else {
      next({ name: 'sites' })
    }
  }
}
</script>
